// extracted by mini-css-extract-plugin
export default {"title":"_3eLGOmt4","subtitle":"_3kI0qRwI","description":"_2bCGm3g7"};